import { BerthResponse, CreateBerthRequest, UpdateBerthRequest } from '@yard/app/api';
import { IBerthFormData } from '../models/yard-setup.model';

export const mapBerthFormDataToCreateCommand = (
  data: IBerthFormData,
  position?: { x: number; y: number },
): CreateBerthRequest => {
  const berth = {
    id: new Date().getTime().toString(), // Temporary ID generation until backend is implemented
    name: data.name,
    quayMeterMarkFrom: data.quayMeterMarkFrom,
    quayMeterMarkTo: data.quayMeterMarkTo,
    maxDraft: data.maxDraft,
    layoutPosition: {
      x: Math.round(position?.x ?? 0),
      y: Math.round(position?.y ?? 0),
      rotation: 0,
    },
    bollards: data.bollards,
    pierId: data.pierId,
  }

  return berth
}

export const mapBerthFormDataToUpdateCommand = (
  data: IBerthFormData,
  berth: BerthResponse,
): UpdateBerthRequest => {
  const updatedBerth = {
    ...berth,
    name: data.name,
    quayMeterMarkFrom: data.quayMeterMarkFrom,
    quayMeterMarkTo: data.quayMeterMarkTo,
    maxDraft: data.maxDraft,
    bollards: data.bollards,
    pierId: data.pierId,
  }

  return updatedBerth
}
